import React, { useState, useEffect } from "react";
import { useForm, FormProvider } from "react-hook-form";
import { Form } from "react-bootstrap";
import RetailBusinessDetails from "./RetailBusinessDetails";
import { AuthService } from "../../../services";
import { toast } from "react-toastify";
import { BusinessProfileService } from "../../../services";
import {
  EventApplicationRetailService,
  EventApplicationService,
  TraderUnitService,
  GlobalSettingService,
} from "../../../services";
import { Link, useNavigate } from "react-router-dom";
import { routes } from "../../../constants/routes";
import { useParams } from "react-router-dom";
import RetailStandDescription from "./RetailStandDescription";
import RetailCostings from "./RetailCostings";
import RetailTermsAndConditions from "./RetailTermsAndConditions";
import RetailPayment from "./RetailPayment";
import CustomModal from "../../../components/Modal/Modal";
import PaymentCard from "../../Common/PaymentCard";
import { ApplicationStatus, ApplicationType } from "../../../constants/Enum";
import { injectModels } from "../../../redux/injectModels";
import CountdownTimer from "../../Common/CountdownTimer";
import RetailDocuments from "./RetailDocuments";
import Swal from "sweetalert2";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { handleConsoleError } from "../../../utils/common-methods";

const RetailApplicationForm = (props) => {
  const [step, setStep] = useState(1);
  const [appData, setAppData] = useState();
  const [isProfileAvailable, setIsProfileAvailable] = useState(true);
  const { eventId, pitchId } = useParams();
  const loginUser = AuthService.getLoginUser();
  const methods = useForm();
  const [isModalOpen, setModalOpen] = useState(false);
  const [paymentDetails, setPaymentDetails] = useState();
  const [stripePromise, setStripePromise] = useState(null);
  const [stripeDetails, setStripeDetails] = useState("");

  const selectedTraderUnit = TraderUnitService.getSelectedTraderUnit() || {
    id: "",
    name: "",
  };

  const navigate = useNavigate();
  const handlePrevious = () => {
    setStep(step - 1);
    if (step <= 3) {
      methods.reset();
    }
  };
  const closeModal = () => {
    setModalOpen(false);
  };

  const getStripeDetails = async () => {
    try {
      const res = await GlobalSettingService.getStripeDetails();
      if (res?.isSuccess && res?.data) {
        setStripeDetails(GlobalSettingService.decrypt(res?.data?.keyValue));
      }
    } catch (error) {
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };
  useEffect(() => {
       getStripeDetails();
  }, []);

  useEffect(() => {
    const getApplicationDetails = async () => {
      try {
        const traderId = selectedTraderUnit?.id;

        // Validate trader unit
        if (!traderId || traderId.length < 3) {
          navigate(routes.DEFAULT);
          return;
        }

        if (!eventId) return;

        const res = await EventApplicationService.getEventApplicationByEventId(
          eventId,
          "R",
        );

        if (!res?.isSuccess || !res?.data?.length) return;

        const application = res?.data?.[0];
        setAppData(application);
        methods.setValue("appType", application?.applicationType);
      } catch (error) {
        const message = handleConsoleError(error);
        toast.error(error?.message || message);
      }
    };

    getApplicationDetails();
  }, [selectedTraderUnit?.id, eventId, methods, navigate]);

  const handleBusinessProfile = (val) => {
    setIsProfileAvailable(val);
  };
  const onSubmit = async (data, e) => {
    if (step > 6) {
      navigate(routes.ACCOUNT_APPLICATIONS);
    } else {
      if (step === 1) {
        //save business details with application
        await SaveRetailApplication(
          data?.retailApplicationFormData,
          data?.businessData,
        );
        // setStep((prevStep) => prevStep + 1);
      }
      if (step > 1 && step < 4) {
        await SaveRetailApplication(data.retailApplicationFormData, null);
        //setStep((prevStep) => prevStep + 1);
      }
      if (step === 4) {
        await SaveDocs(data.doc);
        //setStep((prevStep) => prevStep + 1);
      }
      if (step === 5) {
        await SaveRetailApplication(data.retailApplicationFormData, null);
        //setStep((prevStep) => prevStep + 1);
      }
      if (step === 6) {
        const payment = {
          id: null, // Guid?
          appId: data?.retailApplicationFormData?.id,
          eventId: data?.retailApplicationFormData?.eventId,
          traderId: data?.retailApplicationFormData?.traderId,
          userId: loginUser?.id, // Guid
          title: "Retailer Application Booking Payment", // string?
          amount: data?.payment?.amount, // string?
          applicationFee: data?.payment?.applicationFee, // string?
          buyerFee: data?.payment?.buyerFee, // string?
          processingFee: data?.payment?.processingFee, // string?
          connectedAccountId: data?.payment?.connectedAccountId, //"acct_1QjaTOPfU6Vw7G4t",
          IsCaterer: false,
          remainingAmount: data?.payment?.remainingAmount,
          initialPaymentPer: data?.payment?.initialPaymentPer,
        };
        //payment Check
        if (payment.connectedAccountId) {
          try {
            const stripe = await loadStripe(
              `${stripeDetails}`, // safer than hardcoding
              { stripeAccount: payment.connectedAccountId },
            );

            setStripePromise(stripe);
          } catch (error) {
            const message = handleConsoleError(error);
            toast.error(error?.message || message);
          }
          setPaymentDetails(payment);
          setModalOpen(true);
        } else {
          toast.error(
            "Event organiser linked account is not setup to accept payments.",
          );
        }
      }
    }
  };

  const SaveDocs = async (docs) => {
    try {
      if (docs) {
        const documents = docs.map((x) => {
          return { documentId: x.id, documentTypeId: x.documentFor };
        });
        const updatedDocs = {
          EventApplicationId: methods.getValues("retailApplicationFormData.id"),
          Documents: documents,
        };
        const response = await EventApplicationRetailService.updateRetailApplicationDocs(
          updatedDocs,
        );
        if (response?.isSuccess) {
          props.application.setLoading(false);
          methods.setValue(`doc`, []);
          toast.success(response?.message);
          setStep((prevStep) => prevStep + 1);
        } else {
          props.application.setLoading(false);
          toast.error(response?.message || "Something went wrong");
        }
      } else {
        setStep((prevStep) => prevStep + 1);
      }
    } catch (error) {
      props.application.setLoading(false);
      const messgae = handleConsoleError(error);
      toast.error(error?.message || messgae);
    }
  };

  const SaveRetailApplication = async (
    retailApplicationFormData,
    businessData,
  ) => {
    try {
  
      if (retailApplicationFormData !== undefined && step > 1) {
        retailApplicationFormData.initialPaymentPer =
          appData?.initialPaymentPer;
        retailApplicationFormData.payOutDate = appData?.payOutDate;
        retailApplicationFormData.status = ApplicationStatus.InComplete;
        // retailApplicationFormData.additionalpasses===""?
        retailApplicationFormData.additionalpasses =
          retailApplicationFormData.additionalpasses === ""
            ? null
            : retailApplicationFormData.additionalpasses;
        retailApplicationFormData.traderPitchId = selectedTraderUnit.id;
        props.application.setLoading(true);
        const isUpdate =
  typeof retailApplicationFormData?.id === "string" &&
  retailApplicationFormData.id.length > 3;

    const response = isUpdate
          ? await EventApplicationRetailService.updateRetailApplication(retailApplicationFormData)
          : await EventApplicationRetailService.addRetailApplication(retailApplicationFormData);

        if (response?.isSuccess) {
          props.application.setLoading(false);
          methods.setValue("retailApplicationFormData.id", response?.data?.id);
          methods.setValue(
            "retailApplicationFormData.initialPaymentPer",
            response?.data?.initialPaymentPer,
          );
          methods.setValue(
            "retailApplicationFormData.payOutDate",
            response?.data?.payOutDate,
          );
          toast.success(response?.message);
          setStep((prevStep) => prevStep + 1);
        } else {
          props.application.setLoading(false);
          toast.error(response?.message || "Something went wrong");
        }
      }

      if (businessData !== undefined && businessData !== null) {
        await saveBusinessDetails(businessData);
      }
    } catch (error) {
      props.application.setLoading(false);
      const message = handleConsoleError(error);
      const msg = error?.message || message;

      if (msg?.toLowerCase().includes("duplicate")) {
        navigate(routes.DEFAULT);
      } else {
        toast.error(msg);
      }
    }
  };

  const saveBusinessDetails = async (data) => {
    try {
      if (!data.countryId) {
        data.countryId = null;
      }
      data.userId = loginUser?.id;
      if (data.countryId === "") {
        data.countryId = null;
      }
      if (data.stateId === "") {
        data.stateId = null;
      }
      data.numberofemployees =
        data.numberofemployees === null ? 0 : data.numberofemployees;

      props.application.setLoading(true);
      const response = await BusinessProfileService.updateBusinessProfile(data);
      if (response?.isSuccess) {
        // getBusinessProfile();
        // setShowModal(false);
        props.application.setLoading(false);
        toast.success(response?.message);
        setStep((prevStep) => prevStep + 1);
      } else {
        props.application.setLoading(false);
        toast.error(response?.message || "Something went wrong");
      }
    } catch (error) {
      props.application.setLoading(false);
      const message = handleConsoleError(error);
      toast.error(error?.message || message);
    }
  };

  // const calculateDateDifference = (date1, date2) => {
  //   const diffInMilliseconds = new Date(date2) - new Date(date1); // Difference in milliseconds
  //   const diffInDays = diffInMilliseconds / (1000 * 3600 * 24); // Convert milliseconds to days
  //   return diffInDays;
  // };

  const convertDaysToSeconds = (days) => {
    if (!appData?.auctionStartDate) return 0;
    const startDate = appData?.auctionStartDate;
    const endDate = new Date(startDate);
    endDate.setDate(new Date(startDate).getDate() + days);
    const diffInMilliseconds = new Date(endDate) - new Date();
    const secondsInADay = Math.round(diffInMilliseconds / 1000); // 86400; // 1 day = 86,400 seconds
    if (secondsInADay < 0) {
      Swal.fire({
        title: "Auction Expire",
        text: "This Auction has expired. You can no longer apply.",
        icon: "warning",
        buttonsStyling: false,
      });
      navigate(routes.DEFAULT);
    }
    return secondsInADay ?? 0;
  };

  return (
    <Elements stripe={stripePromise}>
      <React.Fragment>
        <CustomModal isOpen={isModalOpen} onClose={closeModal}>
          <PaymentCard paymentDetails={paymentDetails}></PaymentCard>
        </CustomModal>
        {isProfileAvailable === true && (
          <div>
            <section className="subscription-banner">
              <div className="container">
                <h3>Trader Application Booking Form</h3>
              </div>
            </section>

            <section className="create-an-events">
              <div className="container">
                <section>
                  Your Selected Unit :: {selectedTraderUnit?.name}
                </section>
                <div className="create-steps">
                  <ul
                    className="cd-breadcrumb triangle nav nav-tabs"
                    role="tablist"
                  >
                    <li
                      role="presentation"
                      className={`step ${
                        step === 1 ||
                        step === 2 ||
                        step === 3 ||
                        step === 4 ||
                        step === 5 ||
                        step === 6
                          ? "active"
                          : ""
                      }`}
                    >
                      <span
                        aria-controls="ideate"
                        role="tab"
                        data-toggle="tab"
                        aria-expanded="true"
                      >
                        Details
                      </span>
                    </li>
                    <li
                      role="presentation"
                      className={`step ${
                        step === 2 ||
                        step === 3 ||
                        step === 4 ||
                        step === 5 ||
                        step === 6
                          ? "active"
                          : ""
                      }`}
                    >
                      <span
                        aria-controls="submit"
                        role="tab"
                        data-toggle="tab"
                        aria-expanded="false"
                      >
                        Stand Description
                      </span>
                    </li>
                    <li
                      role="presentation"
                      className={`step ${
                        step === 3 || step === 4 || step === 5 || step === 6
                          ? "active"
                          : ""
                      }`}
                    >
                      <span
                        aria-controls="discuss"
                        role="tab"
                        data-toggle="tab"
                        aria-expanded="false"
                      >
                        Costings
                      </span>
                    </li>
                    <li
                      role="presentation"
                      className={`step ${
                        step === 4 || step === 5 || step === 6 ? "active" : ""
                      }`}
                    >
                      <span
                        aria-controls="get-validated"
                        role="tab"
                        data-toggle="tab"
                        aria-expanded="false"
                      >
                        Documents
                      </span>
                    </li>
                    <li
                      role="presentation"
                      className={`step ${
                        step === 5 || step === 6 ? "active" : ""
                      }`}
                    >
                      <span
                        aria-controls="get-validated"
                        role="tab"
                        data-toggle="tab"
                        aria-expanded="false"
                      >
                        Terms & Conditions
                      </span>
                    </li>
                    <li
                      role="presentation"
                      className={`step ${step === 6 ? "active" : ""}`}
                    >
                      <span
                        aria-controls="work"
                        role="tab"
                        data-toggle="tab"
                        aria-expanded="false"
                      >
                        Payment
                      </span>
                    </li>
                  </ul>

                  <div className="tab-content">
                    <Form.Group controlId="appType">
                      <Form.Control
                        type="hidden"
                        {...methods.register("appType")}
                      />
                    </Form.Group>
                    {appData?.applicationType > ApplicationType.Fixed &&
                      appData?.applicationType < ApplicationType.Turnover && (
                        <div className="ps-3">
                          Auction ending in :
                          <div className="bid-100">
                            <CountdownTimer
                              duration={convertDaysToSeconds(
                                appData?.auctionsDays,
                              )}
                            ></CountdownTimer>
                          </div>
                        </div>
                      )}
                    <FormProvider {...methods}>
                      <Form onSubmit={methods.handleSubmit(onSubmit)}>
                        {step === 1 && (
                          <div
                            role="tabpanel"
                            className="tab-pane active"
                            id="businessdetails"
                          >
                            <RetailBusinessDetails
                              handleBusinessProfile={handleBusinessProfile}
                            ></RetailBusinessDetails>
                          </div>
                        )}

                        {step === 2 && (
                          <div
                            role="tabpanel"
                            className="tab-pane active"
                            id="GetValidated"
                          >
                            <RetailStandDescription
                              eventId={eventId}
                              appId={appData?.id}
                              pitchId={pitchId}
                            ></RetailStandDescription>
                          </div>
                        )}
                        {step === 3 && (
                          <RetailCostings
                            eventId={eventId}
                            pitchId={pitchId}
                          ></RetailCostings>
                        )}
                        {step === 4 && <RetailDocuments></RetailDocuments>}
                        {step === 5 && (
                          <RetailTermsAndConditions></RetailTermsAndConditions>
                        )}
                        {step === 6 && (
                          <RetailPayment props={props}></RetailPayment>
                        )}
                      </Form>
                    </FormProvider>
                  </div>
                  <div className="navigation-buttons mt-3 mb-3 px-2">
                    {step > 1 && (
                      <button type="button" onClick={handlePrevious}>
                        Previous
                      </button>
                    )}
                    {step < 6 && (
                      <button
                        type="button"
                        onClick={methods.handleSubmit(onSubmit)}
                      >
                        Save & Continue
                      </button>
                    )}
                    {step === 6 && (
                      <button
                        type="button"
                        onClick={methods.handleSubmit(onSubmit)}
                      >
                        Save
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </section>
          </div>
        )}
        {isProfileAvailable === false && (
          <div>
            <section className="create-an-events">
              <div className="container">
                <div className="create-steps">
                  <div role="tabpanel" className="tab-pane">
                    <h3>
                      Please setup your business profile first{" "}
                      <Link to={routes.ACCOUNT_BUSINESSINFO}>Click here</Link>{" "}
                      to go to business profile
                    </h3>
                  </div>
                </div>
              </div>
            </section>
          </div>
        )}
      </React.Fragment>
    </Elements>
  );
};

export default injectModels(["application"])(RetailApplicationForm);
